module.exports = __webpack_public_path__ + "static/media/020_intel3_8.d929eed6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/intel/020_intel3_8.png
// module id = 490
// module chunks = 0